<template>
  <v-menu
    offset-y
  >
    <v-btn
      slot="activator"
      flat
      icon
      small
      color="info lighten-2"
      class="ma-0"
    >
      <v-icon small>
        help
      </v-icon>
    </v-btn>
    <div>
      <v-card class="light-blue lighten-5">
        <v-card-text style="width: 550px">
          <div>除特貨和禁寄品以外大部分商品均可寄普貨。</div>
          <div>特貨：液體、膏狀、粉末、帶電池、帶磁性、帶馬達的物品請寄特貨。</div>
          <div>
            禁寄品：酒、毒品、槍支、水果、植物、電話卡(網卡)、易燃易爆物、電動車類(平衡車、滑板車)、電子煙相關產品...
          </div>
          <div class="mt-2">
            空運體積限制：
            單邊長度不可超過160cm，三邊長度不能同時有兩邊超過70cm和85cm (例如：60*50*170 不可以，75*90*20 不可以)
          </div>
          <div>
            空運重量限制：
            單件不能超過70KG
          </div>
        </v-card-text>
      </v-card>
    </div>
  </v-menu>
</template>

<script>
export default {

}
</script>

<style>

</style>
